export const defaultData: Country = {
  allowedCurrencies: ['EUR', 'USD', 'MXN'],
  countryCode: 'IE',
  locales: ['en', 'lt'],
  name: '',
};
